import { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import "./style.css";
import { IoChevronBackOutline } from "react-icons/io5";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Carteras() {
  const [isOpenNft0, setIsOpenNft0] = useState(false);
  const [isOpenNft1, setIsOpenNft1] = useState(false);
  const [isOpenNft2, setIsOpenNft2] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-neutral-900">
      <div class="page-bg animation-wrapper">
        <div class="particle particle-1"></div>
      </div>
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-6">
        
          <h1 class="text-white mt-2 block uppercase text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
            MetaMask
          </h1>
          <h3 class="block text-xl text-violet-600 font-semibold tracking-wide ">
            Más información sobre Metamask y cómo mantener la seguridad.
          </h3>

          <a href="/learn" className="font-bold ml-2 text-left flex text-white">
            <IoChevronBackOutline className="mr-2 mt-1" /> volver 
            </a>

          <ul role="list" class="space-y-3 text-left">
            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft0(!isOpenNft0)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">¿Qué es MetaMask?</h2>
                <svg
                  className={`${
                    isOpenNft0
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft0}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      MetaMask es{" "}
                      <strong>
                        uno de los monederos más populares de Ethereum
                      </strong>
                      . Es reconocida por su interfaz de usuario sencilla que no
                      sólo sirve para almacenar y gestionar Ether y otros tokens
                      ERC-20, sino que también permite a los usuarios gastar
                      monedas en juegos, comerciar con ellas en intercambios
                      descentralizados, apostar tokens en aplicaciones de juegos
                      de azar, y lo más importante, almacenar tu arte digital
                      (NFTs).
                    </p>
                    <p>
                      Para instalar la Metamask para tu navegador, haz clic en
                      el siguiente enlace:{" "}
                      <a
                        style={{ color: "blue" }}
                        href="https://metamask.io/"
                        target="_blank"
                      >
                        https://metamask.io/
                      </a>
                    </p>
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft1(!isOpenNft1)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Cómo usar MetaMask?
                </h2>
                <svg
                  className={`${
                    isOpenNft1
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft1}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Descarga MetaMask desde metamask.io para tu navegador
                      preferido y también para tu teléfono (iOS/Android). Sigue
                      los pasos descritos y lo que es más importante,{" "}
                      <strong>
                        escribe tu "frase semilla" de recuperación en un lugar
                        seguro (fuera de línea)
                      </strong>
                      . La frase semilla es vital para acceder a tus activos.{" "}
                      <strong>
                        ¡Si pierdes tu frase semilla, tu billetera se perderá
                        para siempre!
                      </strong>
                    </p>
                    <p>
                      <strong>Consejos útiles en la configuración:</strong>
                    </p>
                    <ul className="list-decimal">
                      <li>
                        <strong>Sincronización con el móvil</strong>: después de
                        configurar tu MetaMask, puedes vincularla a tu teléfono
                        dirigiéndote a la pestaña "Avanzado" y haciendo clic en
                        "sincronizar con el móvil".
                      </li>
                      <li>
                        <strong>Restablecer cuenta</strong>: en la pestaña
                        "Avanzado", tienes la opción de borrar tu historial de
                        transacciones de MetaMask (esto no afectará tus activos)
                        haciendo clic en "restablecer cuenta".
                      </li>
                      <li>
                        <strong>Configuración de moneda</strong>: cambia tu
                        moneda principal y tu preferencia de conversión de
                        moneda en "General".
                      </li>
                    </ul>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft2(!isOpenNft2)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Cómo enviar criptomonedas desde MetaMask?
                </h2>
                <svg
                  className={`${
                    isOpenNft2
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft2}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <ul className="list-decimal">
                      <li>
                        Para enviar tus activos desde tu cartera de MetaMask a
                        otra cartera digital o electrónica, dirígete a la página
                        principal de MetaMask y haz clic en "enviar".
                      </li>
                      <li>
                        Pega la dirección de la cartera de recepción donde se te
                        solicite.
                      </li>
                      <li>Elige el activo y la cantidad que deseas enviar.</li>
                    </ul>
                    <p>
                      <b>
                        RECUERDA VERIFICAR SIEMPRE DOS VECES LA DIRECCIÓN DE LA
                        CARTERA A LA QUE ESTÁS ENVIANDO.
                      </b>
                    </p>
                    <p>
                      <strong>Frase semilla = Contraseña</strong>
                    </p>
                    <p>
                      Una frase semilla, o una frase de recuperación, es tu
                      <strong>
                        clave para acceder a tus activos en el mundo cripto y
                        NFT.
                      </strong>
                    </p>
                    <p>
                      Es una cadena de palabras que es un código para una cadena
                      más larga de números, y solo TÚ sabes cuáles son.
                    </p>
                    <p>
                      Tú no creas la frase. Por lo general, se te asignan entre
                      10 y 24 palabras (en un orden específico) cuando creas tu
                      cartera electrónica nueva.
                    </p>
                    <p>
                      <b>
                        <i>
                          Es fundamental que esta frase permanezca en secreto.
                        </i>
                      </b>
                    </p>
                    <p>
                      Tan pronto que alguien más conozca tu frase
                      semilla/recuperación, no podrás cambiar esa situación.
                    </p>
                    <p>
                      Ahora tienen acceso a tus activos digitales y es probable
                      que ya los hayan robado.
                    </p>
                    <p>
                      Entonces, ahora que sabes que tu frase semilla o de
                      recuperación es tu clave supersecreta personal para
                      acceder a sus activos digitales, ¡hablemos sobre cómo
                      mantenerla segura a continuación!
                    </p>
                    <p>
                      <b>Seguridad de la frase semilla</b>
                    </p>
                    <p>
                      Tu frase semilla o frase de recuperación es tu clave súper
                      secreta personal para acceder a tus activos digitales.
                    </p>
                    <p>
                      Cuando abres una cartera nueva, esto es lo que vas a hacer
                      cuando se trata de esa frase superespecial—
                      <b>
                        no puedes perderla ni revelar la semilla/recuperación:
                      </b>
                    </p>
                    <ul className="list-decimal">
                      <li>
                        <strong>Escríbelo</strong>. Escríbelo literalmente en
                        una hoja de papel.
                      </li>
                      <li>
                        <strong>
                          No lo guardes en línea ni en ningún otro lugar de su
                          teléfono
                        </strong>
                        . Cuantas más veces se muestre o guarde la frase en una
                        pantalla, más fácil será que alguien la encuentre. Esto
                        significa en cualquier lugar digitalmente: no tomes una
                        foto. No lo pongas en Google Docs o Evernote. No lo
                        guardes en un administrador de contraseñas.
                      </li>
                      <li>
                        <strong>
                          Guarda la copia física de la frase semilla/frase de
                          recuperación en un lugar seguro que solo tu sepas
                          dónde encontrarla, y posiblemente con una o dos copias
                          de seguridad en otro lugar.
                        </strong>
                        <br />
                        Cuando usas muchas carteras electrónicas, tú eres la
                        ÚNICA persona que tiene esta frase, por lo que, en la
                        mayoría de los casos, si la pierde, desaparece. No
                        existe tal cosa como un restablecimiento de contraseña
                        aquí.
                        <br />
                        Incluso puedes considerar almacenar diferentes partes de
                        la frase en diferentes lugares para aumentar el nivel de
                        seguridad.
                        <br />
                        Manténlo seguro y sé dónde encontrarlo.
                      </li>
                      <li>
                        <strong>Nunca, jamás le des la frase a nadie</strong>.
                        La única vez que deberías necesitar ver tu frase inicial
                        es cuando se genera para una nueva cartera o si
                        necesitas recuperar tu cartera electrónica existente.
                        <br />
                        Nadie necesitará tu frase en ningún momento. Si lo
                        hacen, es una estafa.
                      </li>
                    </ul>
                    <strong>Frase semilla: ¡repasemos!</strong>
                    <p>
                      Una frase semilla o de recuperación es tu clave súper
                      secreta personal para acceder a tus activos digitales.
                    </p>
                    <p>
                      Nunca debe almacenar esta frase digitalmente, y debe tener
                      una copia escrita (y tal vez una copia de seguridad o dos)
                      en un lugar seguro que solo tu puedes encontrar.
                    </p>
                    <p>
                      Nunca jamás compartas tu frase semilla/recuperación con
                      nadie. Nadie. Si alguien pregunta, quiere robar tus cosas.{" "}
                      <strong>Un Gran No.</strong>
                    </p>
                    <p>
                      <strong>
                        Recuerda que estas son simplemente sugerencias de
                        mejores prácticas y no una forma infalible de mantener
                        todo seguro
                      </strong>
                      . Ahora que hemos eliminado la primera (y más seria)
                      seguridad, ¡deberías sentirte (solo un poco) más seguro
                      para mantener seguros tus activos y tu cartera!
                    </p>
                    <strong>Almacenamiento de NFT</strong>
                    <ul class="list-disc">
                      <li>Has elegido una cartera electrónica.</li>
                      <li>Has comprado algo de ETH.</li>
                      <li>
                        Has investigado y decidido apoyar un proyecto/artista de
                        NFT.
                      </li>
                    </ul>
                    <p>
                      Pero una vez que apruebas esa transacción, ¿dónde se
                      almacena el NFT?
                    </p>
                    <p>La respuesta es corta: ¡en una cartera electrónica!</p>
                    <p>Profundicemos en la respuesta larga…</p>
                    <p>
                      Imagina que la cadena de bloques de Ethereum es un gran
                      museo. Hay todo tipo de cosas exhibidas en este museo, y
                      en el fondo de una de las salas, ¡su nuevo NFT está
                      colgado para que el mundo lo vea!
                    </p>
                    <p>
                      <strong>
                        Un proyecto NFT se divide en 2 partes: el contrato
                        inteligente y la obra de arte digital que está
                        representada por “metadatos”
                      </strong>
                      .
                    </p>
                    <p>
                      El contrato inteligente existe en la cadena de bloques y
                      se personaliza para contener reglas, estándares y
                      elementos específicos del proyecto (es decir, precio de
                      minteo, número de tokens, etc.). El contrato inteligente
                      contiene una regla que apunta al servidor que almacena la
                      obra de arte digital.
                    </p>
                    <p>
                      La obra de arte digital puede no vivir en la cadena de
                      bloques y puede almacenarse en un servidor fuera de línea,
                      como un sistema de archivos interplanetarios{" "}
                      <b>“InterPlanetary File System (IPFS)”</b>, que es un
                      "servidor de almacenamiento centralizado". Cabe señalar
                      que no todas las colecciones de NFT usan 'IPFS' y se
                      almacenan realmente en la cadena (por ejemplo, la
                      colección NFT “On-Chain Monkey”).
                    </p>
                    <p>
                      El NFT que se encuentra en tu cartera electrónica te
                      brinda el certificado de autenticidad y la prueba de
                      propiedad.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
